/*
 * Copyright (c) 2024 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain
 * proprietary information of OCLC, Inc. and shall not be disclosed in whole or in
 * any part to any third party or used by any person for any purpose, without written
 * consent of OCLC, Inc.  Duplication of any portion of these  materials shall include this notice.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Close as CloseIcon } from 'mdi-material-ui';

import { StyledAlert, StyledIconButton } from './styles';

const CloseButton = React.memo(({ onClose }) => {
  return onClose !== null && onClose !== undefined ? (
    <StyledIconButton
      key='close'
      aria-label='Close'
      color='inherit'
      onClick={onClose}
    >
      <CloseIcon />
    </StyledIconButton>
  ) : null;
});

const Alert = ({ className, message, onClose, variant, ...other }) => {
  return (
    <StyledAlert
      aria-live='assertive'
      severity={variant}
      className={className}
      action={<CloseButton onClose={onClose} />}
      onClose={onClose}
      {...other}
    >
      {message}
    </StyledAlert>
  );
};

Alert.propTypes = {
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

export default React.memo(Alert);
